export function ucfirst(str: string) {
	if (!str) return '';
	str = str.toLowerCase();
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function format_currency(amount: number | string, no_decimals = false) {
	if (amount === undefined || amount === null || amount === '') return '0';

	if (typeof amount === 'string') {
		const parsed = parseFloat(amount);
		if (isNaN(parsed)) {
			return '0';
		}
		amount = parsed;
	}

	return amount.toLocaleString('en-US', {
		minimumFractionDigits: no_decimals ? 0 : 2,
		maximumFractionDigits: no_decimals ? 0 : 2
	});
}

/**
 * Formats an identification number with the country's UID prefix.
 * If a prefix is provided, it will prepend it to the identification number.
 * If no prefix is provided (empty string), it returns the identification number as-is.
 * If the identification number already contains a "-", it will not add the prefix to avoid duplication.
 *
 * @param identificationNumber - The identification number to format
 * @param uidPrefix - The UID prefix from CountrySettings (e.g., 'PER-' for Peru, empty string if not applicable)
 * @returns The formatted identification number with prefix
 *
 * @example
 * format_identification_with_prefix('12345678', 'PER-') // returns 'PER-12345678'
 * format_identification_with_prefix('12345678', '') // returns '12345678'
 * format_identification_with_prefix('PER-12345678', 'PER-') // returns 'PER-12345678'
 */
export function format_identification_with_prefix(identificationNumber: string, uidPrefix: string): string {
	if (!identificationNumber || typeof identificationNumber !== 'string') return '';
	const trimmed = identificationNumber.trim();
	if (trimmed.includes('-')) return trimmed;
	return uidPrefix ? `${uidPrefix}${trimmed}` : trimmed;
}

export function remove_prefix_from_identification(identificationNumber: string): string {
	if (!identificationNumber || typeof identificationNumber !== 'string') return '';
	const trimmed = identificationNumber.trim();
	const dashIndex = trimmed.indexOf('-');
	if (dashIndex >= 0) {
		return trimmed.substring(dashIndex + 1);
	}
	return trimmed;
}

export function format_currency_usd(amount: number): string {
	return new Intl.NumberFormat('es-ES', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2
	}).format(amount);
}

export function format_currency_short(amount: number): string {
	return `$${amount.toFixed(2)}`;
}

export function format_date(dateStr: string | null | undefined): string {
	if (!dateStr) return '—';
	try {
		const d = new Date(dateStr);
		if (isNaN(d.getTime())) return dateStr;
		return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
	} catch {
		return dateStr;
	}
}

export function format_date_time(dateStr: string | null | undefined): string {
	if (!dateStr) return '—';
	try {
		const d = new Date(dateStr);
		if (isNaN(d.getTime())) return dateStr;
		return d.toLocaleDateString('es-ES', {
			day: '2-digit',
			month: 'short',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		});
	} catch {
		return dateStr;
	}
}